<template>
  <div class="action-sheet">
    <div class="action-sheet-mask" @click="closeAction"></div>
    <div class="action-sheet-content">
      <div class="sheet-title">选择调入分会</div>
      <div class="sheet-content">
        <ul class="sheet-list">
          <li
            class="sheet-item"
            v-for="item in sheetList"
            :key="item.id"
            @click="selectBranch(item)"
          >{{item.content}}</li>
        </ul>
      </div>
      <div class="sheet-footer"></div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  name: "actionSheet",
  data() {
    return {};
  },
  props: {
    sheetList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    selectBranch(item) {
      this.$emit("selectBranch", item);
    },
    closeAction(){
      this.$emit("close");
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
.action-sheet {
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 50;
  width: 100%;

  .action-sheet-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #25262d;
    opacity: 0.4;
    pointer-events: auto;
  }

  .action-sheet-content {
    height: 205px;
    width: 100%;
    position: absolute;
    bottom: 0;
    background: #fff;

    .sheet-title {
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #e8e8f1;
      color: #888;
    }

    .sheet-list {
      height: 165px;
      overflow: auto;

      .sheet-item {
        height: 40px;
        line-height: 40px;
        text-align: center;

        &:active {
          background-color: rgba(0, 0, 0, 0.04);
        }
      }
    }
  }
}
</style>
